import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.cherryRed,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 30
  const h = 30
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m10.918 22.396-.376-.207-3.96 1.259 1.287-3.796-.243-.399a8.64 8.64 0 0 1-1.262-4.51C6.364 9.922 10.304 6 15.182 6 20.06 6 24 9.921 24 14.743c0 4.82-3.94 8.742-8.818 8.742a8.824 8.824 0 0 1-4.264-1.089Zm-4.146-2.623L5 25l5.436-1.728a9.825 9.825 0 0 0 4.746 1.213c5.423 0 9.818-4.363 9.818-9.742C25 9.362 20.605 5 15.182 5s-9.818 4.362-9.818 9.743a9.64 9.64 0 0 0 1.408 5.03Zm7.973-7.477c.119.237.29.718.016 1.263a2.727 2.727 0 0 1-.386.601c.175.244.42.546.712.806a4.3 4.3 0 0 0 1.066.706l.274-.347c.18-.27.484-.545.938-.596.324-.037.608.068.696.1l.013.005c.158.057.528.233.81.368.316.151.633.307.743.36l.002.002.1.048.033.016c.044.021.103.05.162.082.088.048.346.188.52.475v.001c.145.238.164.488.17.562v.002c.01.127.007.26-.004.39a3.636 3.636 0 0 1-.204.903c-.205.569-.706.961-1.036 1.174-.723.438-1.309.548-2.04.548-.511 0-1.119-.233-2.202-.655-1.273-.498-2.272-1.375-2.947-2.102a11.35 11.35 0 0 1-1.107-1.403 6.087 6.087 0 0 1-.564-.898c-.236-.46-.502-1.134-.502-1.878 0-1.369.717-2.125.965-2.388.242-.256.532-.43.869-.533.29-.087.582-.12.884-.132.05-.002.389-.014.724.186.343.204.541.527.669.833l.626 1.501Zm4.438 4.162.117.057c.147.07.247.118.29.189.052.087.052.508-.125.999-.176.491-1.43 1-1.43 1s-.388.316-2.543-.526c-1.992-.779-3.304-2.711-3.574-3.11l-.046-.065c-.105-.14-.864-1.14-.864-2.174 0-.967.48-1.476.7-1.709l.041-.044c.194-.21.619-.263.619-.263s.228-.037.352-.037h.013c.123 0 .294 0 .463.405.059.138.143.343.233.559.183.442.386.932.42 1.002.054.105.09.227.019.368l-.03.06a1.197 1.197 0 0 1-.182.291 8.464 8.464 0 0 0-.11.13c-.072.088-.145.175-.208.238-.105.105-.216.22-.093.43.124.21.55.897 1.18 1.455.678.6 1.268.854 1.566.982.057.024.103.044.138.061.212.105.335.088.458-.052.124-.14.53-.614.672-.825.14-.21.282-.175.476-.105.194.07 1.237.58 1.448.684Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
